import { render, staticRenderFns } from "./EssayDetail.vue?vue&type=template&id=1945b695&scoped=true&"
import script from "./EssayDetail.vue?vue&type=script&lang=js&"
export * from "./EssayDetail.vue?vue&type=script&lang=js&"
import style0 from "./EssayDetail.vue?vue&type=style&index=0&id=1945b695&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945b695",
  null
  
)

export default component.exports